import { useReportLoading } from './useReportLoading';

/** Reports loading to the shared overlay while mounted and renders nothing. */
export const RouteLoadingReporter = (): null => {
  useReportLoading(true);
  return null;
};
